import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.scss';
import MobileApp from './mobileApp/containers/MobileApp';
import { LoadingOverlay } from './web/classes/LoadingOverlay';

const Website = React.lazy(() => import('./web/Website'));

const App = () => (
  <Suspense fallback={<LoadingOverlay />}>
    <Router>
      <Switch>
        <Route path="/dashboard/mobile_app" component={MobileApp} />
        <Route path="/dashboard/" component={Website} />
      </Switch>
    </Router>
  </Suspense>
);

export default App;
